import { FC } from 'react'
import { Container } from './SendForApproval.styles'
import { ButtonClicked, TSendForApprovalProps } from './SendForApproval.types'

import LoadingButton from 'components/molecules/LoadingButton/LoadingButton'
import { useSendForApprovalLogic } from './SendForApproval.logic'

const SendForApproval: FC<TSendForApprovalProps> = ({
  surgery,
  handleSetAssetStatus,
  setAssetStatusMutation,
  setAssetStatusSecondaryMutation,
  setIsQrOpen,
}) => {
  const {
    isGroupedAssetsEmpty,
    numberOfExpiredHardware,
    disableSendForApproval,
    showSendForRepApproval,
    handleSendForApproval,
    FormValidationAlertToasters,
    setButtonClicked,
    showGenerateGuestRepTokenTab,
  } = useSendForApprovalLogic({
    surgery,
    handleSetAssetStatus,
    setAssetStatusMutation,
    setAssetStatusSecondaryMutation,
    setIsQrOpen,
  })

  return (
    <>
      {FormValidationAlertToasters()}

      <form onSubmit={handleSendForApproval}>
        <input
          type="hidden"
          name="numberOfExpiredHardware"
          value={numberOfExpiredHardware}
        />
        <Container>
          {showSendForRepApproval && (
            <LoadingButton
              type="submit"
              dataTestId="send-for-rep-approval-button"
              loading={setAssetStatusMutation.loading}
              loadingText="Sending for rep approval"
              sx={{ mb: 1.5 }}
              disabled={disableSendForApproval}
              onClick={() =>
                setButtonClicked(ButtonClicked.SEND_FOR_REP_APPROVAL)
              }
            >
              Send for rep approval
            </LoadingButton>
          )}
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
          >
            <LoadingButton
              id="no-industry-rep-available-button"
              type="submit"
              dataTestId="no-industry-rep-available-button"
              mode="secondary"
              loading={setAssetStatusSecondaryMutation.loading}
              loadingText="Marking ready for approval"
              variant="outlined"
              disabled={isGroupedAssetsEmpty}
              onClick={() => setButtonClicked(ButtonClicked.NO_REP_AVAILABLE)}
            >
              Approve without a rep
            </LoadingButton>

            {showGenerateGuestRepTokenTab && (
              <LoadingButton
                id="approve-and-reconcile-with-guest-rep-button"
                dataTestId="approve-and-reconcile-with-guest-rep-button"
                mode="secondary"
                loading={setAssetStatusSecondaryMutation.loading}
                loadingText="Marking ready for approval"
                variant="outlined"
                disabled={isGroupedAssetsEmpty}
                onClick={() => setIsQrOpen({ isOpen: true, type: 'guest' })}
              >
                Approve and reconcile with guest rep
              </LoadingButton>
            )}
          </div>
        </Container>
      </form>
    </>
  )
}

export default SendForApproval
